import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "jni-manager-report-notes",
  templateUrl: "./manager-report-notes.component.html",
  styleUrls: ["./manager-report-notes.component.scss"],
  imports: [FormsModule],
})
export class ManagerReportNotesComponent {
  @Input() manager = "";
  @Input() bc = "";
  @Input() notes = "";
  @Input() bcPersonnelNumber = "";
  @Input() type = "";
  @Output() cancelEvent = new EventEmitter<boolean>();
  @Output() submitEvent = new EventEmitter<{
    manager: string;
    bcPersonnelNumber: string;
    notes: string;
    type: string;
  }>();
  managerName = "";

  onCancel() {
    this.cancelEvent.emit(true);
  }

  onSubmit() {
    this.submitEvent.emit({
      manager: this.manager,
      bcPersonnelNumber: this.bcPersonnelNumber,
      notes: this.notes,
      type: this.type,
    });
  }
}
